module.exports = __webpack_public_path__ + "static/media/Delhi TMCP Icons-2.fef8cf0f.png";